var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"split-content",class:{ 'is-split': _vm.isSplit }},[_c('div',{staticClass:"split-content__left"},[_vm._t("left")],2),(_vm.isSplit)?_c('div',{staticClass:"split-content__right",style:({ backgroundImage: `url(${_vm.splashImgName})` })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }